import React, { ReactNode, useMemo } from 'react'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import { useBrand } from 'scripts/brand/BrandContext'

// OEM / ホワイトラベル: partner の brandColor を MUI テーマの palette.primary に反映する。
// tailwind の `locked`(var(--brand-primary, #4c5cb6)) や直書き hex の var 化と揃え、MUI の
// color="primary" を使う要素（パスワード / PIN コード更新ボタン、accessRequest 等）も partner
// 色に追従させる。CSS 変数だけでは MUI が内部で primary を実色解決する箇所（contrastText 計算等）に
// 追従しないため、brandColor の実 hex で MUI テーマを生成する（frontend-ts の createAppTheme と同方針）。
//
// 既定（未設定 / LOCKED / 中立 / 不正値）は DEFAULT_PRIMARY(#4c5cb6) にする。これは tailwind `locked`
// の fallback・console / frontend-ts のブランド既定色と一致し、bg-locked と MUI primary が同じ既定色で
// 揃う（従来の MUI デフォルト青 #1976d2 はブランド既定色 #4c5cb6 に統一される）。
const DEFAULT_PRIMARY = '#4c5cb6'
const BRAND_COLOR_HEX = /^#[0-9a-fA-F]{6}$/

export const BrandedThemeProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const brand = useBrand()
  const primaryMain =
    brand.brandColor && BRAND_COLOR_HEX.test(brand.brandColor)
      ? brand.brandColor
      : DEFAULT_PRIMARY
  // primaryMain が変わったときだけテーマを作り直す（毎 render の再生成を避ける）。
  const theme = useMemo(
    () => createTheme({ palette: { primary: { main: primaryMain } } }),
    [primaryMain],
  )
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}
